import { matchForSavedOptionalAttribute } from "../utils/utils";

export function prepareEditedAttributes(edited: any = [], allAttributeOptions: any = [], shopify_attributes: any = []) {
    let modifiedArr: any = [];
    if (edited.length > 0) {
        edited?.map((ele: any) => {
            if (matchForSavedOptionalAttribute(ele['amazon_attribute'], allAttributeOptions)) {
                let temporary: any = formatEditedVariantAttribute(allAttributeOptions, ele?.['amazon_attribute'], ele);
                modifiedArr.push({ ...temporary });
            }
        })
    }
    return modifiedArr
}

function getMatchingAmazonAttribute(toMatch: string = '', amazon_attributes: any = [], isValue: boolean = false, comparator: string = '') {
    let temp: any = '';
    let abort = false;
    amazon_attributes.forEach((ele: any) => {
        Object.keys(ele).forEach((elem: any) => {
            if (typeof ele[elem] === 'object') {
                if (!abort) {
                    ele[elem].map((attr: any) => {
                        if (isValue) {
                            if (toMatch === attr?.['amazon_attribute'] || toMatch === attr?.['value']) {
                                temp = attr?.['value'];
                                abort = true
                            }
                        }
                        else if (comparator === 'shopify_select') {
                            attr?.['shopify_select']?.['options'].forEach((ele: any) => {
                                if (ele?.['value'] === toMatch) {
                                    temp = { options: attr?.['shopify_select']?.['options'] };
                                    temp = { ...temp, value: ele }
                                    abort = true
                                }
                            })
                        }
                        else if (comparator === 'shopify_attribute') {
                            let tempShopifyAttribute: any = [];
                            attr?.['shopify_attribute']?.['options']?.map((event: any, ind: number) => {
                                Object.keys(event?.options)?.map((events: any, index: number) => {
                                    tempShopifyAttribute.push(event?.options?.[events]);
                                });
                            })
                            tempShopifyAttribute?.forEach((ele: any) => {
                                if (ele?.['value'] === toMatch) {
                                    temp = { options: attr?.['shopify_attribute']?.['options'] };
                                    temp = { ...temp, value: ele }
                                    abort = true
                                }
                            })
                        }
                        else if (comparator === 'recommendation') {
                            attr?.['recommendation']?.['options'].forEach((ele: any) => {
                                if (ele?.['value'] && ele?.['value'] != '' && ele?.['value'] === toMatch) {
                                    temp = { options: attr?.['recommendation']?.['options'] };
                                    temp = { ...temp, value: ele }
                                    abort = true
                                }
                            });
                        }
                        else {
                            if (toMatch === attr?.['amazon_attribute'] || toMatch === attr?.['value']) {
                                temp = attr?.['amazon_attribute'];
                                abort = true
                            }
                        }
                    })
                }
            }
        })
    })


    return temp;
}

function formatEditedVariantAttribute(arr: any[], toMAtc: any, allData: any) {
    let matc: any = {};
    arr?.forEach((ele: any) => {
        ele['options']?.forEach((ele1: any) => {
            if (ele1.value == toMAtc) {
                let temp: any = [];
                ele1['shopify_attribute']?.['options']?.map((event: any, ind: number) => {
                    Object.keys(event?.options)?.map((events: any, index: number) => {
                        temp.push(event?.options?.[events]);
                    });
                })
                matc = {
                    ...ele1,
                    custom_text: allData?.['custom_text'] ?? '',
                    shopify_select: {
                        value: ele1['shopify_select']?.['options']?.filter((t: { value: any; }) => t.value === allData?.['shopify_select'])[0] ?? [],
                        options: ele1['shopify_select']?.['options']
                    },
                    recommendation: {
                        value: ele1['recommendation']?.['options']?.filter((t: { value: any; }) => t.value === allData?.['recommendation'])[0] ?? '',
                        options: ele1['recommendation']?.['options']
                    },
                    shopify_attribute: {
                        value: temp?.filter((t: { value: any; }) => t.value === allData?.['shopify_attribute'])[0] ?? '',
                        options: ele1['shopify_attribute']?.['options']
                    }
                };
            }
        })
    })
    return matc;
}

export function changeEditedVariantAttributeFormat(edited_variant_attributes: any) {
    let tempAttributeData: any = [];
    edited_variant_attributes?.length > 0 && edited_variant_attributes?.map((elem: any, index: number) => {
        tempAttributeData.push({
            amazon_attribute: elem?.['amazon_attribute'] ?? '',
            shopify_attribute: elem?.['shopify_attribute']?.['value']?.['value'] ?? '',
            recommendation: elem?.['recommendation']?.['value']?.['value'] ?? '',
            custom_text: elem?.['custom_text'] ?? '',
            shopify_select: elem?.['shopify_select']?.['value']?.['value'] ?? '',
        })
    })
    return tempAttributeData;
}
